//* @param {Ref} element a ref of the element to scroll to the top off
//*
export const scrollToTop = (element) => {
  element.current.scroll({
    top: 0,
    left: 0,
    behavior: "smooth",
  });
};

/**
 *
 * @param {string} phoneNumberString number to return in the format +1 (123) 456-7890
 * @returns
 */
export const formatPhoneNumber = (phoneNumberString) => {
  var cleaned = ("" + phoneNumberString).replace(/\D/g, "");
  var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    // var intlCode = match[1] ? '+1 ' : '';
    return ["(", match[2], ") ", match[3], "-", match[4]].join("");
  }
  return null;
};

/**
 * Reroutes a freshly verified user to the correct destination based on the role
 * they signed up with. Returns true when a redirect was triggered.
 *
 * - intern / life_insurance_agent -> BPO Homes intern payment page (/internPrice)
 * - wholesaler                    -> BPO Homes wholesaler payment page (/wholesale)
 * - ind_prof                      -> industry professionals site (no payment here)
 * - realty_agent / client         -> no redirect (existing in-app flow)
 * - everyone else                 -> straight to bpotech.io as regular outside agents
 *
 * @param {string} role user role captured at signup
 * @param {(path: string) => void} navigate react-router navigate fn for in-app routes
 */
export const routeAfterSignup = (role, navigate) => {
  if (!role) return false;

  const techBase = process.env.REACT_APP_BPOHOMESTECH_REDIRECT;
  const industryProfessionalsUrl =
    process.env.REACT_APP_INDUSTRY_PROFESSIONALS_URL ||
    "https://industryprofessionals.com/";
  const accessToken = localStorage.getItem("uta");
  const refreshToken = localStorage.getItem("utr");

  switch (role) {
    case "intern":
    case "life_insurance_agent":
      navigate("/internPrice");
      return true;
    case "wholesaler":
      navigate("/wholesale");
      return true;
    case "ind_prof":
      window.location.assign(industryProfessionalsUrl);
      return true;
    case "realty_agent":
    case "client":
      return false;
    default:
      window.location.assign(
        `${techBase}?uta=${accessToken}&utr=${refreshToken}&link=/`,
      );
      return true;
  }
};

export const convertCurrencySystem = (labelValue) => {
  // Nine Zeroes for Billions
  return Math.abs(Number(labelValue)) >= 1.0e9
    ? (Math.abs(Number(labelValue)) / 1.0e9).toFixed(2) + "B"
    : // Six Zeroes for Millions
    Math.abs(Number(labelValue)) >= 1.0e6
    ? (Math.abs(Number(labelValue)) / 1.0e6).toFixed(2) + "M"
    : // Three Zeroes for Thousands
    Math.abs(Number(labelValue)) >= 1.0e3
    ? (Math.abs(Number(labelValue)) / 1.0e3).toFixed(1) + "K"
    : Math.abs(Number(labelValue));
};

export const getAllDaysInMonth = (year, month) => {
  const today = new Date().getDate();
  const date = new Date(year, month, today);

  const dates = [];

  while (date.getMonth() === month) {
    dates.push(new Date(date).toDateString());
    date.setDate(date.getDate() + 1);
  }

  return dates;
};
